import type { JSX } from 'solid-js'

export function GotoIcon(props: JSX.SvgSVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <g>
        <rect
          x="-0.75"
          y="0.75"
          width="30.5"
          height="30.5"
          rx="15.25"
          transform="matrix(-1 0 0 1 30.5 0)"
          fill="white"
          fill-opacity="0.56"
        />
        <rect
          x="-0.75"
          y="0.75"
          width="30.5"
          height="30.5"
          rx="15.25"
          transform="matrix(-1 0 0 1 30.5 0)"
          fill="#333333"
          style={{ 'mix-blend-mode': 'color-dodge' }}
        />
        <rect
          x="-0.75"
          y="0.75"
          width="30.5"
          height="30.5"
          rx="15.25"
          transform="matrix(-1 0 0 1 30.5 0)"
          stroke="url(#paint0_linear_719_2829)"
          stroke-width="1.5"
        />
        <path
          d="M14 11L19 16L14 21"
          stroke="black"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_719_2829"
          x1="17.1339"
          y1="-6.0049e-07"
          x2="26.1639"
          y2="29.2083"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="white" stop-opacity="0.3" />
          <stop offset="1" stop-color="white" stop-opacity="0.1" />
        </linearGradient>
      </defs>
    </svg>
  )
}
